;
/*!
 * SubitoTexto.loadMorePosts.js
 */
SubitoTexto.submitArticle = {
	init      : function () {
		var $ = jqPla,
			_this = SubitoTexto.submitArticle


		// Also serves to check if we're in the right place.
		_this.$mainContainer = $( '.soumission-article' );
		_this.$form = $( '#form-article-submission' );


		if ( _this.$form.length < 1 ) {
			// Nothing to do on this page
			return;
		}


		if ( typeof CONFIG == 'undefined' || CONFIG.submit_article_url == 'undefined' ) {
			console.error( '[SubitoTexto.submitArticle] Need the URL to load more' );
			return;
		}


		// Inputs
		_this.$inputName = _this.$form.find( '#fullname' );
		_this.$inputCity = _this.$form.find( '#city' );
		_this.$inputAge = _this.$form.find( '#age' );

		_this.$uploadField = _this.$form.find( '.pla-html5input-wrapper' ).find( 'input[type=file]' );
		_this.$btnBrowse = _this.$form.find( '.pla-html5input-browse-btn' );
		_this.$messageSuccess = _this.$mainContainer.find( '.message-success' );
		_this.iMaxUploadSizeInMegs = 2;

		_this.$inputTitle = _this.$form.find( '#soumission-article-titre' );
		_this.$inputContent = _this.$form.find( '#soumission-article-article' );
		_this.$inputAgreed = _this.$form.find( '#soumission-article-confirmation' );


		new Fingerprint2( {
			excludeAvailableScreenResolution: true,
			excludeScreenResolution         : true
		} ).get( function ( result, components ) {
			_this.fingerprint = result;
		} );


		_this.bindEvents();


	},
	bindEvents: function () {
		var $ = jqPla,
			_this = SubitoTexto.submitArticle

		_this.$form.on( 'submit', function ( e ) {
			e.preventDefault();

			if ( $( this ).hasClass( 'disabled' ) ) {
				return false;
			}

			_this.processForm();
		} );


		_this.$uploadField.on( 'change', function ( e ) {
			_this.showFileFieldChanges( $( this ), e );
		} );


		_this.$uploadField.on( 'focus', function ( e ) {
			_this.$btnBrowse.addClass( 'focused' );
		} );

		_this.$uploadField.on( 'blur', function ( e ) {
			_this.$btnBrowse.removeClass( 'focused' );
		} );
	},

	showFileFieldChanges: function ( $fileField, event ) {
		var $ = jqPla,
			_this = SubitoTexto.concours_inscription;

		var $neighbourFilenameSpan = $fileField.siblings( '.file-path' ),
			fileValues = event.target.files,
			filename = false;

		if ( fileValues ) {
			if ( typeof fileValues[ 0 ] != 'undefined' && fileValues[ 0 ][ 'name' ] != 'undefined' ) {
				filename = fileValues[ 0 ][ 'name' ];
			}
		}

		if ( $neighbourFilenameSpan.length > 0 ) {

			if ( filename ) {
				$neighbourFilenameSpan.html( filename ).addClass( 'file-chosen' ).attr( 'title', filename );
				$fileField.parents( '.pla-html5input-wrapper' ).addClass( 'has-file' );
			}
		}

	},


	processForm: function () {
		var $ = jqPla,
			_this = SubitoTexto.submitArticle;


		var formData = new FormData();


		formData.append( 'fullname', _this.$inputName.val() );
		formData.append( 'city', _this.$inputCity.val() );
		formData.append( 'age', _this.$inputAge.val() );
		formData.append( 'soumission-article-titre', _this.$inputTitle.val() );
		formData.append( 'soumission-article-article', _this.$inputContent.val() );
		formData.append( 'is-agreed', _this.$inputAgreed.is( ':checked' ) );
		formData.append( 'fingerprint', _this.fingerprint );


		_this.$formResults = $( '.form-submission-results' );
		var fileSizeError = false;


		if ( window.File && window.FileReader && window.FileList && window.Blob ) {


			if ( typeof _this.$uploadField[ 0 ].files != 'undefined' && _this.$uploadField[ 0 ].files.length > 0 && typeof _this.$uploadField[ 0 ].files[ 0 ] != 'undefined' ) {
				var iFileErrors = 0,
					file = _this.$uploadField[ 0 ].files[ 0 ],
					fsize = file.size,
					ftype = file.type,
					fname = file.name;


				if ( fsize > 1024 * 1024 * _this.iMaxUploadSizeInMegs ) {
					// too big

					// $( '<div class="error-message error-specific-input error-file-size">La taille maximale de fichier acceptée est de ' + _this.iMaxUploadSizeInMegs + 'Mo <a href="#' + _this.$uploadField.attr( 'id' ) + '">Corriger</a></div>' ).appendTo( _this.$formResults );
					// iFileErrors++;
					fileSizeError = true;

				} else {

					fileSizeError = false;
				}


				// if ( iFileErrors > 0 ) {
				// 	return false;
				// }

				formData.append( 'imageData', _this.$uploadField[ 0 ].files[ 0 ] );
			}
		}


		$.ajax( {
			url        : CONFIG.submit_article_url,
			dataType   : 'json',
			type       : 'post',
			processData: false,
			contentType: false,
			data       : formData
		} )
			.done( function ( _data ) {

				if ( typeof _data.success == 'undefined' || _data.success != 1 || fileSizeError ) {
					// problem

					SubitoTexto.form.processForm( _this.$form, _data.errors, true );
					//console.log( 'fileSizeError', fileSizeError );

					if ( fileSizeError ) {
						$( '<div class="error-message error-specific-input error-file-size">La taille maximale de fichier acceptée est de ' + _this.iMaxUploadSizeInMegs + 'Mo <a href="#' + _this.$uploadField.attr( 'id' ) + '">Corriger</a></div>' ).appendTo( _this.$formResults );
					}


				} else {
					// success!

					_this.$form.slideUp();
					_this.$messageSuccess.find('p').slideDown( );
				}

			} );

	}
};
